import {initArticleReactionsAndComments} from '../modules/card-counters';

document.addEventListener('DOMContentLoaded', () => {
  initArticleReactionsAndComments();
});
